module.exports = __webpack_public_path__ + "media/assets/services_manager/flags/chinese-4f747c79ad96bda7a2f581f2fad36789b44a497155f6e1984d12102c982842da.png";